$(document).ready(function() {
    var window_width = $(window).width();
    if(window_width < 768){
     $('.usp-bar-list-wrapper').slick({
      dots: false,
      arrow: false,
      infinite: false,
      autoplay: true,
      speed : 8000,
      slidesToShow: 1,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
    }
});
  
    var $tabs = $('.tabs li.tab-link, .tabs li a.linked');
    $tabs.on('click', function (el) {
      el.preventDefault(); // toggle active tab

      $tabs.removeClass('is-active active');
      $(this).addClass('is-active');
      var $tabIndex = $(this).index();
      var $tabContent = $(this).parents('.tabs').next('.tabs-content'); // toggle corresponding tab content
      var $tabImages = $(this).parents('#page-menu').find('.nav-image-blocks');
      var $tabCTA = $(this).parents('#page-menu').find('.nav-ctas');
      $tabContent.children('li, li a').removeClass('is-active active');
        $tabContent.children('li, li a').eq($tabIndex).addClass('is-active').siblings().removeClass('is-active');
      $tabImages.children('.nav-images__wrapper').removeClass('is-active active');
        $tabImages.children('.nav-images__wrapper').eq($tabIndex).addClass('is-active').siblings().removeClass('is-active');
      $tabCTA.children('.nav-ctas__wrapper').removeClass('is-active active');
        $tabCTA.children('.nav-ctas__wrapper').eq($tabIndex).addClass('is-active').siblings().removeClass('is-active');

    });
    
    $('.js-menu__heading').click(function(e){
      $(this).toggleClass('heading-active');
      $(this).parents('.custom.has-children').find('.grand-children').toggleClass('mobile-hide');
    });
$('a.menu__heading.empty-heading').click(function(e){
      $(this).toggleClass('heading-active');
      $(this).parents('.custom.has-children').find('.links-categories').toggleClass('mobile-hide');
    });
$('.js-image__heading').click(function(e){
  e.preventDefault();
      $(this).toggleClass('heading-active');
      $(this).parent().find('.mega-menu-image-list-wrapper').toggleClass('mobile-hide');
    });